export default __webpack_public_path__ + "static/media/10_lordf 1.236e0874.svg";